export const THEME_STORAGE_KEY = "toolbox-color-theme";

export function normalizeTheme(value) {
  return value === "light" || value === "dark" ? value : null;
}

export function resolveTheme(storedTheme, prefersDark) {
  return normalizeTheme(storedTheme) || (prefersDark ? "dark" : "light");
}

export function readStoredTheme(storage) {
  try {
    return normalizeTheme(storage?.getItem(THEME_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function storeTheme(storage, theme) {
  const normalized = normalizeTheme(theme);
  if (!normalized) return false;
  try {
    storage?.setItem(THEME_STORAGE_KEY, normalized);
    return Boolean(storage);
  } catch {
    return false;
  }
}

export function toggledTheme(theme) {
  return normalizeTheme(theme) === "dark" ? "light" : "dark";
}

export function themeSwitchState(theme) {
  const isDark = normalizeTheme(theme) === "dark";
  return {
    isDark,
    ariaChecked: String(isDark),
    title: isDark ? "Switch to light mode" : "Switch to dark mode"
  };
}
